/* @flow */
import { toIdValue } from 'apollo-utilities';
import { dataIdFromObject } from '../memory';

export const organizations = (_: *, args: *): string | void => {
  if (args.uuids) {
    return args.uuids.map(uuid => {
      const dataId = dataIdFromObject({ __typename: 'Organization', uuid });
      return dataId ? toIdValue(dataId) : undefined;
    });
  }

  return undefined;
};
